import i18n from '@/i18n';
import _Vue from 'vue';
import { Location } from 'vue-router';
import { RouteNames } from '@/utils/router/router.models';
import { Dictionary } from 'vue-router/types/router';

export const tRoute = (RouteName: RouteNames, params?: Dictionary<string>, query?: Dictionary<string>): Location => {
  return {
    name: i18n.t(`global.routes.${RouteName}.name`) as string,
    params: { lang: i18n.locale.split('-')[0], ...params },
    query
  };
};

export function tRoutePlugin(Vue: typeof _Vue): void {
  Vue.prototype.$tRoute = tRoute;
}
